module.exports = __webpack_public_path__ + "img/template-02.1b7b3677.svg";